import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDStack,
} from '@facet-wealth/design';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { dataAttrs } from 'Helpers/Testing';
import { QuizWrapperLayout } from 'Views/FreemiumEntry/HasRelationship/Content/Components/QuizWrapperLayout';
import { ProgressBar } from 'Views/FreemiumEntry/HasRelationship/Content/Templates/PicklistQuestion/ProgressBar';
import { QuestionCard } from './QuestionCard';

const MultiPicklistQuestion = ({ setLink }) => {
  const { resource } = useMetaLayoutContext();
  useScrollTopOnMount();
  useBoneBackgroundColor();

  return (
    <QuizWrapperLayout setLink={setLink}>
      <FDStack direction={'column'} spacing={4} {...dataAttrs('question-container')}>
        <ProgressBar />
        <QuestionCard key={resource.link('self').url()} />
      </FDStack>
    </QuizWrapperLayout>
  );
};

export { MultiPicklistQuestion };
